import RecipesModal from './RecipesModal';

export default RecipesModal;
